// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x5UcM","clinicsSelect":"styles_clinicsSelect__fWyb2"};